module.exports = "/_next/static/images/Sina_Mohseninejad-29cda3add8f74f2c5d287fceeff97805.webp";